/**
 * @flow
 * @relayHash 564c2ea0db2eb000a713ac0f3328a2e4
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type VehicleIncidentTypeTable_viewer$ref = any;
export type VehicleIncidentTypeIndexQueryVariables = {||};
export type VehicleIncidentTypeIndexQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: VehicleIncidentTypeTable_viewer$ref
  |}
|};
export type VehicleIncidentTypeIndexQuery = {|
  variables: VehicleIncidentTypeIndexQueryVariables,
  response: VehicleIncidentTypeIndexQueryResponse,
|};
*/


/*
query VehicleIncidentTypeIndexQuery {
  viewer {
    ...VehicleIncidentTypeTable_viewer
  }
}

fragment VehicleIncidentTypeTable_viewer on Viewer {
  vehicleIncidentTypes(first: 20, orderBy: [code], order: ASC) {
    edges {
      node {
        id
        code
        name
        suggestedMileage
        suggestedMonths
        isDisabled
        __typename
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  },
  {
    "kind": "Literal",
    "name": "order",
    "value": "ASC"
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      "code"
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "VehicleIncidentTypeIndexQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "VehicleIncidentTypeTable_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "VehicleIncidentTypeIndexQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "vehicleIncidentTypes",
            "storageKey": "vehicleIncidentTypes(first:20,order:\"ASC\",orderBy:[\"code\"])",
            "args": (v0/*: any*/),
            "concreteType": "VehicleIncidentTypeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "VehicleIncidentTypeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "VehicleIncidentType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "id",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "code",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "suggestedMileage",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "suggestedMonths",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isDisabled",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "__typename",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cursor",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasNextPage",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "endCursor",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "vehicleIncidentTypes",
            "args": (v0/*: any*/),
            "handle": "connection",
            "key": "VehicleIncidentTypeTable_vehicleIncidentTypes",
            "filters": [
              "orderBy",
              "order",
              "where"
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "VehicleIncidentTypeIndexQuery",
    "id": null,
    "text": "query VehicleIncidentTypeIndexQuery {\n  viewer {\n    ...VehicleIncidentTypeTable_viewer\n  }\n}\n\nfragment VehicleIncidentTypeTable_viewer on Viewer {\n  vehicleIncidentTypes(first: 20, orderBy: [code], order: ASC) {\n    edges {\n      node {\n        id\n        code\n        name\n        suggestedMileage\n        suggestedMonths\n        isDisabled\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b4a87578604e9295f668860e2744aaf0';
module.exports = node;
